/* @@flow */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
// $FlowIgnore
import _ from 'lodash';

import Column from 'components/UIKit/Flex/Column';

function lastchild(children) {
  /*
   * When the children's values (in an array) are [object, object, object, false/0/null],
   * #filter removes these false-y values - in fact, any values (object or not) without
   * the 'props.id' property defined, as spacerHeight depends on 'props.id'
   */
  return _.last(_.filter(children, child => _.has(child, 'props.id')));
}

let baseStyle = {
  fontSize: '1rem',
  height: 'calc(100vh - 167px)',
  overflowY: 'auto',
};

export default class Content extends Component {
  static propTypes = {
    children: PropTypes.any,
    style: PropTypes.object,
    handleOnScroll: PropTypes.func,
    getSectionCoords: PropTypes.func
  };

  constructor() {
    super();
    this.sections = {};

    window.addEventListener('resize', this.setupScrollSpy);
  }

  elRef = createRef();
  spacerRef= createRef();

  componentDidMount() {
    this.setupScrollSpy();
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.children !== this.props.children) {
      this.setupScrollSpy();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setupScrollSpy);
  }

  setupScrollSpy = (): void => {
    let spacerHeight = this.spacerHeight(this.elRef.current, this.props.children, this.sections);
    if (this.spacerRef) {
      this.spacerRef.current.style.minHeight = `${spacerHeight}px`;
    }

    let coords = Object.keys(this.sections).reduce((acc, sid) => {
      let node = this.sections[sid]?.sectionRef;
      return {
        ...acc,
        [sid]: {
          id: sid,
          top: node.current?.offsetTop,
          bottom: node.current?.offsetTop + node.current?.clientHeight
        }
      };
    }, {});

    this.props.getSectionCoords(coords);
  };

  sections: Object;

  spacerHeight(parent: Object, children: Object, refs: Object): number {
    let lastChild: Object = children.constructor === Array ? lastchild(children) : children;
    if (lastChild) {
      const lastNode = refs[lastChild.props.id];
      return parent?.clientHeight - lastNode.sectionRef?.current?.clientHeight;
    }
  }

  render(): React.Element {
    let { children, style, handleOnScroll, router } = this.props;

    return (
      <Column
        onScroll={handleOnScroll}
        style={{
          ...baseStyle,
          ...style,
          height: (router || {location: {pathname: ''}}).location.pathname.includes('dashboard')
            ? '100vh'
            : baseStyle.height
        }}
        tabIndex="0"
        ref={this.elRef}
        >
        {React.Children.map(children, child => child && React.cloneElement(child, {
          ref: (ref) => {
            if (ref) { this.sections[ref.props.id] = ref; }
          },
        }))}
        <div ref={this.spacerRef} />
      </Column>
    );
  }
}
